import React from 'react';
import { Clock } from 'lucide-react';
import { getTransactionIcon, getStatusBadge, isDebit } from './utils';

/** Transactions tab body — full transaction history list. */
export default function TransactionsList({ transactions }) {
  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-900">Transaction History</h3>
      {transactions.length === 0 ? (
        <div className="text-center py-12 bg-gray-50 rounded-xl">
          <Clock className="w-12 h-12 text-gray-400 mx-auto mb-3" />
          <p className="text-gray-500">No transactions yet</p>
        </div>
      ) : (
        <div className="space-y-2">
          {transactions.map((txn) => (
            <div
              key={txn._id}
              className="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition"
            >
              <div className="flex items-center gap-3">
                <div className="p-2 bg-white rounded-lg shadow-sm">
                  {getTransactionIcon(txn.type)}
                </div>
                <div>
                  <p className="font-medium text-gray-900">{txn.description}</p>
                  <p className="text-xs text-gray-500">
                    {new Date(txn.created_at).toLocaleString()}
                    {txn.bank_account_name && ` • ${txn.bank_account_name}`}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className={`font-semibold ${isDebit(txn.type) ? 'text-red-600' : 'text-green-600'}`}>
                  {isDebit(txn.type) ? '-' : '+'}${txn.amount.toFixed(2)}
                </p>
                {getStatusBadge(txn.status)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
